import { NavLink } from "react-router-dom";
import { House, Briefcase, Search, Wallet2, Gear } from "react-bootstrap-icons";
import "./style.css";

const Walletsidebar = () => {
  return (
    <div className="wallet-sidebar d-flex flex-column p-2">
      <div className="d-flex flex-column gap-2">
        <NavLink
          to="/wallet-profile"
          className={({ isActive }) =>
            `font_14 ps-0 pe-0 mb-2 ${isActive ? "active" : ""}`
          }
          style={{ fontWeight: "500" }}
        >
          <House className="me-2 ms-2 mb-1 " /> Investor Profile
        </NavLink>

        <NavLink
          to="/invest-form"
          className={({ isActive }) =>
            `font_14 ps-0 pe-0 mb-2 ${isActive ? "active" : ""}`
          }
          style={{ fontWeight: "500" }}
        >
          <Briefcase className="me-2 ms-2  " /> Invest with us
        </NavLink>

        <NavLink
          to="/explor-opportunities"
          className="font_14 ps-0 pe-0 mb-2"
          style={{ fontWeight: "500" }}
        >
          <Search className="me-2 ms-2 mb-1 " /> Opportunities
        </NavLink>

        <NavLink
          to="/wallet-portfolio"
          className={({ isActive }) =>
            `font_14 ps-0 pe-0 mb-2 ${isActive ? "active" : ""}`
          }
          style={{ fontWeight: "500" }}
        >
          <Wallet2 className="me-2 ms-2 mb-1 " /> My Portfolio
        </NavLink>

        <NavLink
          to="/withdrawal-setting"
          className={({ isActive }) =>
            `font_14 ps-0 pe-0 mb-2 ${isActive ? "active" : ""}`
          }
          style={{ fontWeight: "500" }}
        >
          <Gear className="me-2 ms-2 mb-1 " /> Settings
        </NavLink>
      </div>
    </div>
  );
};

export default Walletsidebar;
